import React from 'react'
import { FormattedMessage } from 'react-intl';
 
function CheckEmailModal(props) {
  const { error, sentEmail, closeModal } = props;
  return (
    <div>
      <div 
        className="modal fade"
        id="checkEmailModal" 
        tabIndex="-1" 
        role="dialog"
        aria-labelledby="checkEmailModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              {sentEmail ? 
                <h2 className="text-center text-success mb-4"><FormattedMessage id="SEND_EMAIL_SUCCESS" /></h2> :
                <h2 className="text-center text-error mb-4"><FormattedMessage id="SEND_EMAIL_FAILED" /></h2>
              }
              {error ?
                <p className="text-center">{error}</p> :
                <p className="text-center"><FormattedMessage id="CHECK_EMAIL_FOR_RESET_PASSWORD" /></p>
              }
              <div className="row justify-content-center">
                <button type='button' id="doneBtn" className='btn btn-primary btn-block mb-1' onClick={closeModal}><FormattedMessage id="DONE_BTN" /></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" id="backdrop" style={{display: "none"}}></div>
    </div>
  )
}

export default CheckEmailModal